import React from 'react'
import { withRouter } from 'react-router-dom';
import {Box,Card,CardHeader, CardBody,Button,Heading, Text,CardFooter} from 'grommet';
import { Alert,Update } from 'grommet-icons';
import { NavigationSnackBar } from '../../components/utils/shared/shared';



function QuoteFail(props) {
  const quote = props.location.state.quote
  if (props.location.state.error){
    return (
        <Box>
          <NavigationSnackBar title={'Shipment Unsuccuessful'} user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'},{name: 'Create Shipment', link: '/shipments/new'}]}  />
          <Box direction='column' justify="center" margin='small'>
              <Card pad="medium" gap="small" justify='start' align='start'>
                  <CardHeader>
                  <Alert color='status-critical'/>
                      <Heading level={4} size="small">Shipment Quote Unsuccessful</Heading>
                  </CardHeader>
                  <CardBody justify='start' direction='column'>
                      <Text size='small'>Please check the shipment details and ensure all addresses are correct.</Text>
                      <Text size='small'>If the problem persists, please contact support on  <a href="mailto:labship@samplelogistics.com?subject=LabShip Shipment Error">labship@samplelogistics.com</a>.</Text>
                  </CardBody>
                  <CardFooter>
                      <Button margin="small" icon={<Update color='status-ok'/>} label={"Try Again"} type='button' onClick={() => props.history.push({pathname: '/quote/new', data: quote})}/>
                  </CardFooter>
              </Card>
          </Box>
      </Box>
    )
  } else {
  return (
    <Box>
        <NavigationSnackBar title='Quote Unsuccuessful' user={props.user} pages={[{name: 'Dashboard', link:'/dashboard'},{name: 'Create Quote', link: '/quote/new'}]}  />
        <Box direction='column' justify="center" margin='small'>
            <Card pad="medium" gap="small" justify='start' align='start'>
                <CardHeader>
                <Alert color='status-critical'/>
                    <Heading level={4} size="small">Quote Unsuccessful</Heading>
                </CardHeader>
                <CardBody justify='start' direction='column'>
                    <Text>Error Code: {quote.response.Status.Code}</Text>
                    <Text>Error Message: {quote.response.Status.Message}</Text>
                </CardBody>
                <CardFooter>
                    <Button margin="small" icon={<Update color='status-ok'/>} label={"Try Again"} type='button' onClick={() => props.history.push({pathname: '/quote/new', data: quote,requote:true})}/>
                </CardFooter>
            </Card>
        </Box>
    </Box>
  )
  }
}

export default withRouter(QuoteFail)
